/* joacă bună — wishlist (localStorage, fără cont, fără aplicație).
   Cheie: jb_wishlist = JSON array de HANDLE-uri produs. */
(function () {
  'use strict';
  var KEY = 'jb_wishlist';

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function save(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(handle) { return get().indexOf(handle) !== -1; }
  function count() { return get().length; }
  function toggle(handle) {
    if (!handle) return false;
    var arr = get();
    var i = arr.indexOf(handle);
    var saved;
    if (i === -1) { arr.push(handle); saved = true; }
    else { arr.splice(i, 1); saved = false; }
    save(arr);
    return saved;
  }

  function fmtMoney(cents) {
    var v = (cents / 100);
    try {
      return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2 }).format(v) + ' lei';
    } catch (e) {
      return v.toFixed(2).replace('.', ',') + ' lei';
    }
  }

  /* —— sincronizare UI —— */
  function syncCounters() {
    var n = count();
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      if (n > 0) { nodes[i].removeAttribute('hidden'); }
      else { nodes[i].setAttribute('hidden', ''); }
    }
  }
  function markToggle(el) {
    var saved = has(el.getAttribute('data-handle'));
    el.classList.toggle('is-saved', saved);
    el.setAttribute('aria-pressed', saved ? 'true' : 'false');
    el.setAttribute('aria-label', saved ? 'Elimină de la favorite' : 'Salvează la favorite');
  }
  function syncToggles() {
    var nodes = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < nodes.length; i++) { markToggle(nodes[i]); }
  }

  function onToggleClick(e) {
    var el = e.target.closest('[data-wishlist-toggle]');
    if (!el) return;
    if (el.tagName === 'A' || el.closest('a')) { e.preventDefault(); }
    e.stopPropagation();
    toggle(el.getAttribute('data-handle'));
    /* actualizează toate butoanele cu același handle (card + PDP) */
    var same = document.querySelectorAll('[data-wishlist-toggle][data-handle="' + el.getAttribute('data-handle') + '"]');
    for (var i = 0; i < same.length; i++) { markToggle(same[i]); }
    syncCounters();
    renderGridItem(el.getAttribute('data-handle')); // dacă suntem pe pagina wishlist
  }

  /* —— pagina wishlist —— */
  function buildCard(prod) {
    var img = (prod.featured_image || (prod.images && prod.images[0]) || '');
    if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
    var li = document.createElement('li');
    li.className = 'jb-card-product jb-wishlist-card';
    li.setAttribute('data-wishlist-item', prod.handle);
    var media = img
      ? '<img class="jb-card-product__img jb-card-product__img--one" src="' + img + '" alt="' + escapeAttr(prod.title) + '" loading="lazy">'
      : '<div class="jb-card-product__noimg" aria-hidden="true"></div>';
    li.innerHTML =
      '<a class="jb-card-product__link" href="/products/' + prod.handle + '">' +
        '<div class="jb-card-product__media">' + media + '</div>' +
      '</a>' +
      '<button class="jb-wish-toggle is-saved" data-wishlist-toggle data-handle="' + prod.handle + '" aria-pressed="true" aria-label="Elimină de la favorite">' + heartSvg() + '</button>' +
      '<div class="jb-card-product__body">' +
        '<h3 class="jb-card-product__title"><a class="jb-card-product__link" href="/products/' + prod.handle + '">' + escapeHtml(prod.title) + '</a></h3>' +
        '<p class="jb-price"><span class="jb-price__current">' + fmtMoney(prod.price) + '</span></p>' +
      '</div>';
    return li;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }
  function heartSvg() {
    return '<svg class="jb-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>';
  }

  function renderGridItem(handle) {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    /* dacă handle-ul nu mai e salvat, scoate cardul existent */
    if (!has(handle)) {
      var ex = grid.querySelector('[data-wishlist-item="' + handle + '"]');
      if (ex) { ex.parentNode.removeChild(ex); }
    }
    updateGridEmpty();
  }
  function updateGridEmpty() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var hasCards = grid.querySelector('[data-wishlist-item]');
    if (empty) { if (hasCards) { empty.setAttribute('hidden', ''); } else { empty.removeAttribute('hidden'); } }
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var handles = get();
    grid.innerHTML = '';
    if (!handles.length) { updateGridEmpty(); return; }
    handles.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod || !prod.handle) return; // produs lipsă/șters — ignoră elegant
          /* nu re-adăuga dacă a fost eliminat între timp */
          if (!has(prod.handle)) return;
          if (grid.querySelector('[data-wishlist-item="' + prod.handle + '"]')) return;
          grid.appendChild(buildCard(prod));
          syncToggles();
          updateGridEmpty();
        })
        .catch(function () {})
        .then(function () { updateGridEmpty(); });
    });
  }

  function init() {
    syncToggles();
    syncCounters();
    renderGrid();
    document.addEventListener('click', onToggleClick);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.JBWishlist = { get: get, has: has, toggle: toggle, count: count };
})();
